import classNames from 'classnames';
import React, { useContext, useState, useEffect } from 'react';
import { X } from '@styled-icons/bootstrap';
import mixpanel from 'mixpanel-browser';
import { useSpaceIDFromPath } from '@/data/space/hooks';
import { Bolt } from '@styled-icons/material';
import sharedStyles from '../../styles/Shared.module.css';
import styles from './UpgradeBanner.module.css';
import { CustomDomainActiveDispatchContext, CustomDomainPopupDispatchContext } from '../CustomDomainPopup/context';
import { STEP_MAP } from '../CustomDomainPopup/constants';
import { EVENT } from '../../analytics';
import { UPGRADE_BANNER_EXPIRY_IN_DAYS, UPGRADE_BANNER_KEY_PREFIX } from '../../constants';

function UpgradeBanner() {
  const setActive = useContext(CustomDomainActiveDispatchContext);
  const [isShow, setIsShow] = useState<boolean>(false);
  const setcustomDomainPopupOpen = useContext(CustomDomainPopupDispatchContext);
  const handleBoxClick = () => {
    mixpanel.track(EVENT.CLICK_ADD_CUSTOM_DOMAIN_SIDEBAR);
    setActive(STEP_MAP.add_custom_domain.key);
    setcustomDomainPopupOpen(true);
  };
  const spaceID = useSpaceIDFromPath();
  const LOCAL_STORAGE_KEY = UPGRADE_BANNER_KEY_PREFIX + spaceID;

  useEffect(() => {
    if (window.localStorage.getItem(LOCAL_STORAGE_KEY) === null
      || Number(window.localStorage.getItem(LOCAL_STORAGE_KEY)) < Date.now()) {
      setIsShow(true);
      if (Number(window.localStorage.getItem(LOCAL_STORAGE_KEY)) < Date.now()) {
        window.localStorage.removeItem(LOCAL_STORAGE_KEY);
      }
    }
  }, []);

  if (!isShow) {
    return null;
  }

  const handleClickCloseButton = (e) => {
    e.stopPropagation();
    const addDaysTimestamp = UPGRADE_BANNER_EXPIRY_IN_DAYS * 24 * 60 * 60 * 1000;
    const expiryTimestamp = Date.now() + addDaysTimestamp;
    window.localStorage.setItem(LOCAL_STORAGE_KEY, String(expiryTimestamp));
    setIsShow(false);
  };

  return (
    <div
      onClick={handleBoxClick}
      role="none"
      className={classNames(sharedStyles.sidebarItem, 'pt-0')}
    >
      <div className={classNames('box-border', 'has-fullwidth', styles.box)}>
        <div role="none" className={styles.close} onClick={handleClickCloseButton}>
          <X size={16} className="with-light-text-color" />
        </div>
        <Bolt size={18} className="with-accent-text-color" style={{ marginRight: 10 }} />
        <div className={styles.container}>
          <div className="with-text-color has-text-weight-medium mb-2">
            Add custom domain
          </div>
          <div className="with-light-text-color mb-2">
            Connect your custom domain to your website.
          </div>
          <div className="with-accent-text-color">
            Configure →
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpgradeBanner;
